export enum AuthApiMethods {
    getMe = "Accounts.GetMe",
    checkAuth = "Auth.CheckAuth",
    refreshTokenPair = "Auth.RefreshTokenPair",
    signIn = "Auth.Signin",
    signUp = "Auth.Signup",
}
